import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { forgotPasswordSchema } from '@koyomi/shared';
import type { z } from 'zod';
import { Button, Input } from '@koyomi/ui';
import { AuthCard } from './AuthCard.tsx';
import { api } from '../../lib/api.ts';

type Input_ = z.infer<typeof forgotPasswordSchema>;

export function ForgotPasswordPage() {
  const { t } = useTranslation(['auth', 'common']);
  const [sent, setSent] = useState(false);
  const form = useForm<Input_>({ resolver: zodResolver(forgotPasswordSchema), defaultValues: { email: '' } });
  const onSubmit = form.handleSubmit(async (values) => {
    await api('/auth/forgot-password', { body: values, global: true }).catch(() => undefined);
    setSent(true);
  });
  return (
    <AuthCard title={t('auth:forgot.title')} subtitle={t('auth:forgot.subtitle')}>
      {sent ? (
        <p>{t('auth:forgot.sent')}</p>
      ) : (
        <form className="k-stack" onSubmit={onSubmit} noValidate>
          <Input label={t('auth:login.email')} type="email" autoComplete="email" autoFocus {...form.register('email')} error={form.formState.errors.email && t('common:errors.VALIDATION_ERROR')} />
          <Button type="submit" variant="primary" size="lg" block loading={form.formState.isSubmitting}>{t('auth:forgot.submit')}</Button>
        </form>
      )}
      <Link to="/login" style={{ textAlign: 'center' }}>{t('common:actions.back')}</Link>
    </AuthCard>
  );
}
